"use client";

import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useContext, useState, useMemo } from "react";
import { getTotalGuestsQtyFromHotelOccupationArray } from "@lib/util/hotels/search-ops";
import { HOTELS_MAX_GUEST_IN_RESERVATION, HOTELS_MAX_ROOMS_IN_RESERVATION } from "@lib/constants";
const MobileFiltersContext = /*#__PURE__*/createContext(null);
export const MobileFiltersProvider = _ref => {
  let {
    children,
    initialPassengersDetails,
    initialCabinOptions,
    initialSelectedCabin = "ECONOMY",
    initialOccupations
  } = _ref;
  // Flights state
  const {
    0: passengersDetails,
    1: setPassengersDetails
  } = useState(initialPassengersDetails || {
    adults: 1,
    children: 0,
    infants: 0,
    infants_with_seat: 0
  });
  const {
    0: cabinOptions,
    1: setCabinOptions
  } = useState(initialCabinOptions || [{
    key: "ECONOMY",
    value: "Economy"
  }, {
    key: "PREMIUM_ECONOMY",
    value: "Premium Economy"
  }, {
    key: "BUSINESS",
    value: "Business"
  }, {
    key: "FIRST_CLASS",
    value: "First Class"
  }]);
  const {
    0: selectedCabin,
    1: setSelectedCabin
  } = useState(initialSelectedCabin);
  const {
    0: isFlightsOpen,
    1: setIsFlightsOpen
  } = useState(false);
  const {
    0: hasPassengerError,
    1: setHasPassengerError
  } = useState(false);

  // Hotels state
  const {
    0: selectedOccupations,
    1: setSelectedOccupations
  } = useState(initialOccupations || [{
    adults: 1,
    children: 0,
    children_ages: []
  }]);
  const {
    0: isHotelsOpen,
    1: setIsHotelsOpen
  } = useState(false);
  const {
    0: showCompleteChildrenAges,
    1: setShowCompleteChildrenAges
  } = useState(false);

  // Flights handlers
  const handleSetCabin = cabin => {
    console.log("🔄 Setting cabin class in context:", cabin);
    setSelectedCabin(cabin);
  };
  const handleQuantityChange = passengerDetails => {
    setPassengersDetails(passengerDetails);
  };
  const incrementPassenger = type => {
    setPassengersDetails(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [type]: prev[type] + 1
    }));
  };
  const decrementPassenger = type => {
    setPassengersDetails(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [type]: Math.max(0, prev[type] - 1)
    }));
  };

  // Hotels handlers
  const addOccupation = () => {
    setSelectedOccupations([...selectedOccupations, {
      adults: 1,
      children: 0,
      children_ages: []
    }]);
  };
  const removeOccupation = index => {
    const newOccupations = selectedOccupations.filter((_, i) => i !== index);
    setSelectedOccupations(newOccupations);
  };
  const updateOccupation = (index, occupation) => {
    const newOccupations = [...selectedOccupations];
    newOccupations[index] = occupation;
    setSelectedOccupations(newOccupations);
  };

  // Computed values for hotels
  const totalGuestsInReservation = useMemo(() => getTotalGuestsQtyFromHotelOccupationArray(selectedOccupations), [selectedOccupations]);
  const allChildrenAgesEntered = useMemo(() => selectedOccupations.every(occupation => !occupation.children_ages.includes(null)), [selectedOccupations]);
  const canAddRoom = useMemo(() => totalGuestsInReservation < HOTELS_MAX_GUEST_IN_RESERVATION && selectedOccupations.length < HOTELS_MAX_ROOMS_IN_RESERVATION, [totalGuestsInReservation, selectedOccupations.length]);
  const canAddGuest = useMemo(() => totalGuestsInReservation < HOTELS_MAX_GUEST_IN_RESERVATION, [totalGuestsInReservation]);
  const contextValue = {
    flightFilters: {
      passengersDetails,
      setPassengersDetails,
      cabinOptions,
      setCabinOptions,
      selectedCabin,
      setSelectedCabin,
      isFlightsOpen,
      setIsFlightsOpen,
      hasPassengerError,
      setHasPassengerError,
      handleSetCabin,
      handleQuantityChange,
      incrementPassenger,
      decrementPassenger
    },
    hotelsFilters: {
      selectedOccupations,
      setSelectedOccupations,
      isHotelsOpen,
      setIsHotelsOpen,
      showCompleteChildrenAges,
      setShowCompleteChildrenAges,
      addOccupation,
      removeOccupation,
      updateOccupation,
      totalGuestsInReservation,
      allChildrenAgesEntered,
      canAddRoom,
      canAddGuest
    }
  };
  return __jsx(MobileFiltersContext.Provider, {
    value: contextValue
  }, children);
};
export const useMobileFilters = () => {
  const context = useContext(MobileFiltersContext);
  if (!context) {
    throw new Error("useMobileFilters must be used within a MobileFiltersProvider");
  }
  return context;
};